// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// Rxjs
import { tap } from 'rxjs/operators';

// Environment
import { environment } from 'environments/environment';
import { DatePipe } from '@angular/common';

@Injectable({
    providedIn: 'root',
})

export class IntakeService {
    Alpha_Common_API_URL: string = environment.apiProtocol + environment.Services.CommonBaseURL;
    //Alpha_Common_API_URL: string = 'https://localhost:44317';
    Alpha_API_URL: string = environment.apiProtocol +environment.Services.AlphaURLSlot2;
    Alpha_PIA_API_URL: string = environment.apiProtocol + environment.Services.PiaURL;
    PostalCode: any;

    constructor(private httpClient: HttpClient) { }

    public getAddressByPostalcodeAndHouseNumber(
        postalcode: string,
        houseNumber: string
    ) {
        return this.httpClient.get(
            this.Alpha_Common_API_URL + '/address/' + postalcode + '/' + houseNumber
        );
    }

    public getPostalCode(houseNumber: string, city: string, street: string) {
        return this.httpClient
            .get(
                this.Alpha_Common_API_URL +
                '/address/' +
                houseNumber +
                '/' +
                street +
                '/' +
                city
            )
            .pipe(tap((x) => (this.PostalCode = x)));
    }

    public prepareHeader(): Object {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Cache-Control', 'no-cache');
        return { headers: headers };
    }

    public getnextdossiernumber(route: string) {
        return this.httpClient.get(this.createCompleteRoute(route, this.Alpha_API_URL), this.prepareHeader());
    }

    private createCompleteRoute(route: string, envAddress: string) {
        return `${envAddress}/${route}`;
    }

    public getPIAsearchResult(route: string, body) {
         body.Birthdate = this.getLocalDate(body.Birthdate);
         body.InsuranceReferenceDate = this.getLocalDate(body.InsuranceReferenceDate);
        return this.httpClient.post(
            this.createCompleteRoute(route, this.Alpha_PIA_API_URL),
            body,
            this.prepareHeader()
        );
    }

    public saveDossier(data: any) {
        const route = 'Dossier/Post';

        return this.httpClient.post(
            this.createCompleteRoute(route, this.Alpha_API_URL),
            data,
            this.prepareHeader()
        );
    }

    public getLocalDate(date : Date)
    {
        if(date != null && date != undefined){
            let offset = new Date().getTimezoneOffset();
            let result = new Date(date);
            result.setMinutes(result.getMinutes() - offset);
            return result;
        }
        return date;
    }

    public getUTCDate(date : Date)
    {
        if(date != null && date != undefined){
            let offset = new Date().getTimezoneOffset();
            let result = new Date(date);
            result.setMinutes(result.getMinutes() + offset);
            return result;
        }
        return date;
    }

    public getGlobusLocationInfo(country : string, serviceType : string, provider : string, city: string){
        return this.httpClient.get(
           this.Alpha_Common_API_URL + '/Globus/SearchLocation/' + country + '/'+ city + '/'+ provider +'/'+ serviceType
        );
    }

    public getServiceTypes(){
        return this.httpClient.get(
            this.Alpha_Common_API_URL + '/Globus/ShowServiceTypes'
         );
    }

    public searchCompany(company : string){
        return this.httpClient.get(
            this.Alpha_Common_API_URL + '/Globus/SearchCompany?company='+company
         );
    }
}